import dashboardThunkActions from "./dashboardThunk";
import {toPermissionMap} from "../../../../helper/utils"

function createExtraReducers() {
  return {
    ...dashboardGroupList(),
    ...dashboardList(),
    ...homeDashboardListing(),
    ...reportListing(),
    ...reportListingDashboard(),
    ...chartListing(),
    ...dashboardChartList(),
    ...reportById(),
    ...businessList(),
  };

  function homeDashboardListing() {
    const { fulfilled, rejected, pending } = dashboardThunkActions.homeDashboardListing;
    return {
      [fulfilled]: (state, action) => {
        state.homeDashboardListing.data = action.payload;
        // transform Permission list
        state.homeDashboardListing.data.permissions=action?.payload?.permissions || {};
        // state.homeDashboardListing.data.permissionMap=toPermissionMap(action?.payload?.permissions)
        state.homeDashboardListing.isLoading = false;
      },
      [pending]: (state, action) => {
        state.homeDashboardListing.data = {};
        state.homeDashboardListing.isLoading = true;
      },
      [rejected]: (state, action) => {
        state.homeDashboardListing.error = action.payload;
        // Important: must be false on reject, otherwise the router shows
        // "Loading..." forever on a 401 (e.g. after a half-completed logout)
        // and the user appears stuck.
        state.homeDashboardListing.isLoading = false;
      },
    };
  }

  function dashboardGroupList() {
    const { fulfilled, rejected } = dashboardThunkActions.dashboardGroupList;
    return {
      [fulfilled]: (state, action) => {
        state.dashboardGroupListing.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.dashboardGroupListing.error = action.payload;
      },
    };
  }

  function dashboardList() {
    const { fulfilled, rejected } = dashboardThunkActions.dashboardList;
    return {
      [fulfilled]: (state, action) => {
        state.dashboardList.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.dashboardList.error = action.payload;
      },
    };
  }

  function reportListingDashboard() {
    const { fulfilled, rejected } =
      dashboardThunkActions.reportListingDashboard;
    return {
      [fulfilled]: (state, action) => {
        state.reportListingDashboard.data = [
          ...state.reportListingDashboard.data,
          action.payload,
        ];
      },
      [rejected]: (state, action) => {
        state.reportListingDashboard.error = action.payload;
      },
    };
  }

  function reportListing() {
    const { fulfilled, rejected } = dashboardThunkActions.reportListing;
    return {
      [fulfilled]: (state, action) => {
        state.reportListing.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.reportListing.error = action.payload;
      },
    };
  }

  function dashboardChartList() {
    const { fulfilled, rejected } = dashboardThunkActions.dashboardChartList;
    return {
      [fulfilled]: (state, action) => {
        state.dashboardChartList.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.dashboardChartList.error = action.payload;
      },
    };
  }

  function chartListing() {
    const { fulfilled, rejected } = dashboardThunkActions.chartListing;
    return {
      [fulfilled]: (state, action) => {
        state.chartListing.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.chartListing.error = action.payload;
      },
    };
  }

  function reportById() {
    const { fulfilled, rejected } = dashboardThunkActions.reportById;
    return {
      [fulfilled]: (state, action) => {
        state.reportListingDashboard.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.reportListingDashboard.error = action.payload;
      },
    };
  }

  function businessList() {
    const { fulfilled, rejected } = dashboardThunkActions.businessList;
    return {
      [fulfilled]: (state, action) => {
        state.businessListing.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.businessListing.error = action.payload;
      },
    };
  }

  function chartList() {
    const { fulfilled, rejected } = dashboardThunkActions.reportListing;
    return {
      [fulfilled]: (state, action) => {
        state.reportListing.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.reportListing.error = action.payload;
      },
    };
  }

  function reportList() {
    const { fulfilled, rejected } = dashboardThunkActions.reportListing;
    return {
      [fulfilled]: (state, action) => {
        state.reportListing.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.reportListing.error = action.payload;
      },
    };
  }
}

const dashboardExtraReducers = createExtraReducers();
export default dashboardExtraReducers;
